import React, { Component } from "react";
import Table from "../../components/generic/table/Table";
import {
  PageContainer,
  PageTitle,
  HeaderContainer,
  HeaderTitle,
} from "../../styles/BasicStyles";
import { GetCulturalAssessments } from "../../infra/requests/CulturalAssessmentsRequests";

class CulturalAssessmentsPage extends Component {
  state = {
    pageSize: 30,
    currentPage: 1,
    filters: "",
    loading: true,
    ready: false,
    rows: [],
    total: 0,
  };

  columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (value) => value?.en || "Cultural Assessment",
    },
    {
      title: "Id",
      dataIndex: "_id",
    },
  ];

  componentDidMount = async () => {
    await this.updateDataTable();
  };

  updateDataTable = async () => {
    this.setState({ loading: true });
    try {
      const { currentPage, pageSize, filters } = this.state;
      const result = await GetCulturalAssessments(
        currentPage,
        pageSize,
        filters
      );

      this.setState({
        rows: result.data.items || [],
        total: result.data.total || 0,
      });
      this.setState({ ready: true, loading: false });
    } catch (e) {
      this.setState({ ready: true, loading: false });
      console.error(e);
    }
  };

  handleOnPressRow = (record) => {
    const { history } = this.props;
    history.push(`/cultural-assessments/${record._id}`);
  };

  handleChangePage = (currentPage) => {
    this.setState({ currentPage }, this.updateDataTable);
  };

  handleChangeRowsPerPage = (currentSize, pageSize) => {
    this.setState({ pageSize, currentPage: 1 }, this.updateDataTable);
  };

  handleFilterChange = (filters) => {
    this.setState({ filters, currentPage: 1 }, this.updateDataTable);
  };

  render() {
    const { rows, total, loading, currentPage, pageSize } = this.state;

    return (
      <React.Fragment>
        <HeaderContainer>
          <HeaderTitle buttons={0}>
            <PageTitle>Cultural Assessments</PageTitle>
          </HeaderTitle>
        </HeaderContainer>
        <PageContainer>
          <Table
            columns={this.columns}
            currentPage={currentPage}
            pageSize={pageSize}
            loading={loading}
            rows={rows}
            showHeader
            emptyIcon="warning"
            emptyText={"There are no cultural assessments"}
            total={total}
            rowKey={"_id"}
            hasPagination={false}
            onPressRow={this.handleOnPressRow}
            handleChangePage={this.handleChangePage}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </PageContainer>
      </React.Fragment>
    );
  }
}

export default CulturalAssessmentsPage;
